import React, { useEffect, useMemo, useState } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import _ from 'lodash';
import { Table } from 'src/components';
import { CollapsibleCategoryRow } from 'src/components/StudioCategoriesTable/components';
import { CloseIcon } from 'src/Icons';
import { columns } from 'src/screens/services/ServicesScreen.data';

const CategoryFilterCardItem = ({
  image,
  selected,
  title,
  onClick,
  withoutCloseIcon = false,
}: any) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '8px',
        height: '44px',
        border: selected ? '1px solid #BF295C' : '1px solid #9C9DA0',
        backgroundColor: selected ? '#FFF8FA' : 'white',
        padding: selected && !withoutCloseIcon ? '0px 0px 0px 6px' : '0px 12px 0px 6px',
        margin: '0px 16px 16px 0px',
        cursor: 'pointer',
      }}
    >
      <Avatar
        variant="rounded"
        src={image}
        sx={{
          width: "32px",
          height: "32px",
          borderRadius: "8px",
          marginRight: '8px',
        }}
      />
      <Typography sx={{
        fontSize: '14px',
        fontWeight: '400',
        color: '#363636',
      }}>
        {title}
      </Typography>

      { selected && !withoutCloseIcon ? <CloseIcon sx={{fontSize: '16px', color: '#BF295C', margin: '0px 6px'}} /> : null}
    </Box>
  );
}

export const StudioCategoriesTable = ({
  studioCategories,
  checkedArray,
  onCategoryCheckChange,
  onServiceCheckChange,
  withoutFilterSection = false,
  withoutEditing = false,
  withSelection = false,
}: any) => {
  const [selectedFilterCategories, setSelectedFilterCategories] = useState([]);

  const [updatedCategories, setUpdatedCategories] = useState(studioCategories || []);

  const categories = useMemo(() => {
    return selectedFilterCategories.length
      ? updatedCategories.filter((el: any) => !!selectedFilterCategories.find((c: any) => c.id === el.id))
      : updatedCategories;
  }, [selectedFilterCategories, updatedCategories]);

  const handleFilterCategory = (category: any) => {
    const isAlreadyExists = !!selectedFilterCategories.find((el: any) => el.id === category.id);
    if (isAlreadyExists) {
      // @ts-ignore
      setSelectedFilterCategories((state: any) => state.filter((el: any) => el.id !== category.id));
    } else {
      // @ts-ignore
      setSelectedFilterCategories((state: any) => [...state, category]);
    }
  }

  useEffect(() => {
    setUpdatedCategories(studioCategories);
  }, [studioCategories]);

  return (
    <Box style={{
      paddingBottom: "16px",
    }}>
      {
        !withoutFilterSection ? (
          <Box sx={{
            display: 'flex',
            flexGrow: 1,
            flexWrap: 'wrap',
            marginBottom: '16px',
          }}>
            <CategoryFilterCardItem
              title={'All'}
              image={'/images/category-filter-all.png'}
              onClick={() => {
                setSelectedFilterCategories([]);
              }}
              selected={!selectedFilterCategories.length}
              withoutCloseIcon
            />
            {
              studioCategories?.map((category: any) => {
                const isSelected = !!selectedFilterCategories.find((el: any) => el.id === category.id);

                return (
                  <CategoryFilterCardItem
                    key={category.id}
                    title={category.title}
                    image={category.image}
                    onClick={() => handleFilterCategory(category)}
                    selected={isSelected}
                  />
                )
              })
            }
          </Box>
        ) : null
      }
      <Box sx={{
        overflow: 'auto',
      }}>
        <Box sx={{
          width: 'fit-content'
        }}>
          <Table
            rows={[]}
            shouldShowOnlyHeader
            columns={columns}
            onRowClick={() => {}}
          />
        </Box>
        {
          categories?.map((category: any) => {
            const existed = checkedArray?.find((el: any) => el.id === category.id);
            const isChecked = existed ? existed.isChecked : false;

            return (
              <CollapsibleCategoryRow
                key={category.id}
                title={category.title}
                category={category}
                isChecked={isChecked}
                checkedCategory={existed}
                onServiceCheckChange={onServiceCheckChange}
                onCategoryCheckChange={onCategoryCheckChange}
                withSelection={withSelection}
                withoutEditing={withoutEditing}
              />
            )
          })
        }
      </Box>
    </Box>
  );
};
